export const RadioGroupRoot = (props: any) => {
	return {
		alignItems: 'flex-top',
		flexDirection: props.align === 'horizontal' ? 'row' : 'column',
		flexWrap: 'wrap',
	};
};
